import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { JobApprovalInboxFragment } from './jobApprovalInbox';

export const GetVerifiableJobs = gql`
  query GetVerifiableJobsQuery($currentDistrictId: Int, $currentDepartmentId: Int) {
    verifiable_jobs(department_id: $currentDepartmentId, district_id: $currentDistrictId) {
      edges {
        node {
          ...JobApprovalInboxFragment
        }
      }
    }
  }
  ${JobApprovalInboxFragment}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const jobs = querySelector(data, 'verifiable_jobs.edges[*].node', []);
  return {
    jobs,
  };
});


const withData = graphql(
  GetVerifiableJobs,
  {
    options: { fetchPolicy: 'network-only' },
  },
);


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
